export const getIsUserEligibleForSurveyBasedOnDate = (userRegistrationData?: string, eligibleAfterDate?: string) => {
  const userRegistrationDate = userRegistrationData ? new Date(userRegistrationData) : new Date();
  const eligibilityDate = new Date(eligibleAfterDate ?? "");

  // Check if the user's registration date is after the eligibility date
  return userRegistrationDate >= eligibilityDate;
};
